import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Logo } from '../assets/svg/logo.svg'
import { ReactComponent as DarkLogo } from '../assets/svg/logo-dark.svg'
import Text from '../elements/Typo/Text'
import moment from 'moment'
import Icon from './icons'
import { useCommonApi } from '../store/api/hooks/commonApiHook'
import TestOpsGenieButton from './testOpsGenie/testopsGenieButton'
import { useUserSelector } from '../store/selectors/userSelector'
import { trackEvent } from '../_common/functions'

const Footer: React.FC<{ dark?: boolean }> = ({ dark }) => {
    const { t } = useTranslation()
    const conmmonApi = useCommonApi()
    const [productInfo, setProductInfo] = useState<any>(null)
    const user: any = useUserSelector()
    const getProdcutInfo = () => {
        conmmonApi.getProdcutInfo(
            {},
            (resp: any) => {
                setProductInfo(resp.data)
            },
            (error: any) => {
                console.log(error)
            },
        )
    }

    useEffect(() => {
        getProdcutInfo()
    }, [])
    return (
        <footer className={`${dark ? 'bg-gray-900' : 'bg-transparent'} h-[52px] flex items-cente justify-between px-2`}>
            <div className={`flex items-center justify-center gap-3 pb-2 `}>
                {dark ? <Logo width="6.417rem" height="1rem" /> : <DarkLogo width="6.417rem" height="1rem" />}

                <Text className={` ${dark ? 'text-white' : 'text-black'} !text-[0.5rem]`}>
                    &copy; {moment().format('YYYY')} {t('AB InBev All rights reserved.')}
                </Text>
            </div>
            <div className="flex items-center justify-center gap-2">
                {user && (
                    <div>
                        <TestOpsGenieButton />
                    </div>
                )}

                <div className="border-2 rounded-[0.5rem] px-[0.75rem] py-[0.35rem]">
                    <Text className="items-center text-[#4E4E4E] !text-[0.6rem]">{productInfo?.app_version}</Text>
                </div>
                <div className="w-[2.2rem] h-[2.2rem] rounded-full bg-gray-100 shadow-1 hover:bg-primary flex justify-center items-center">
                    <a
                        title={t('Need Help or Facing any Issue Please log Here for Help and Support')}
                        href={productInfo?.testops_support}
                        rel="noreferrer"
                        target="_blank"
                        onClick={() => trackEvent('footer_support_link_clicked', { url: productInfo?.testops_support })}
                    >
                        <Icon name="help" size={2} />
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
